import React, { Component } from 'react';
import CalendarMonth from './CalendarMonth';
import CalendarMonthCell from './CalendarMonthCell';
import './Calendar.css';
import PropTypes from 'prop-types';

class Calendar extends Component {

	render() {

		var months = [
			{id: 1, title: 'Jänner'},
			{id: 2, title: 'Februar'},
			{id: 3, title: 'März'},
			{id: 4, title: 'April'},
			{id: 5, title: 'Mai'},
			{id: 6, title: 'Juni'},
			{id: 7, title: 'Juli'},
			{id: 8, title: 'August'},
			{id: 9, title: 'September'},
			{id: 10, title: 'Oktober'},
			{id: 11, title: 'November'},
			{id: 12, title: 'Dezember'},
		];

		let year = this.props.year;
		let dateFrom = new Date();
		let dateTo = new Date();
		let schoolHolidays = [];
		let publicHolidays = [];
		let schoolHolidayNames = [];
		let publicHolidayNames = [];
		let weekNumber = 1;

		// Returns the ISO week of the date.
		let getWeek = (d) => {
			var date = new Date(d.getTime());
			date.setHours(0, 0, 0, 0);
			// Thursday in current week decides the year.
			date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
			// January 4 is always in week 1.
			var week1 = new Date(date.getFullYear(), 0, 4);
			// Adjust to Thursday in week 1 and count number of weeks from date to week1.
			return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000
				- 3 + (week1.getDay() + 6) % 7) / 7);
		}

		let getDayOfYear = (d) => {
			let timestmp = new Date().setFullYear(d.getFullYear(), 0, 1);
			let yearFirstDay = Math.floor(timestmp / 86400000);
			let today = Math.ceil((d.getTime()) / 86400000);
			return today - yearFirstDay;
		}

		if(this.props.data.public && this.props.dateType === 1) {
			for(let publicHoliday of Object.values(this.props.data.public)) {
				dateFrom.setTime(publicHoliday['date']*1000);
				publicHolidays.push([new Date(dateFrom.getTime()).toDateString(), publicHoliday['legal']]);
				publicHolidayNames[new Date(dateFrom.getTime()).toDateString()] = publicHoliday['name'];
			}
		}

		// get all dates of school holidays and save it in array schoolHolidayDates
		if(this.props.data.school && this.props.dateType === 2) {
			for(let schoolHolidayName of Object.keys(this.props.data.school)) {
				dateFrom.setTime(this.props.data.school[schoolHolidayName]['date_from']*1000);
				dateTo.setTime(this.props.data.school[schoolHolidayName]['date_to']*1000);

				// get amount of days the holidays will last - respect end of year
				//let range = (getDayOfYear(dateTo)-getDayOfYear(dateFrom)) > 1 ? (getDayOfYear(dateTo)-getDayOfYear(dateFrom)) : 365 - getDayOfYear(dateFrom);
				// d ... iterates between from and to day of year
				for(let d = 0; d <= (getDayOfYear(dateTo)-getDayOfYear(dateFrom)); d++) {
					let timestamp = dateFrom.getTime() + (d*86400000);
					schoolHolidays.push(new Date(timestamp).toDateString());
					schoolHolidayNames[new Date(timestamp).toDateString()] = schoolHolidayName;
				}
			}

		}

		if(this.props.data.special && this.props.dateType === 2) {
			console.log(this.props.data.special);
			for(let i in this.props.data.special.date) {
				dateFrom.setTime(this.props.data.special.date[i]*1000);
				schoolHolidays.push(new Date(dateFrom).toDateString());
				schoolHolidayNames[new Date(dateFrom).toDateString()] = 'Schulautonomer Tag';
			}
		}


		return (
			<div className="Calendar">
				{months.map(function(month, index){

					let maxDaysOfCurrentMonth = new Date(year,month.id,0).getDate();
					//Wochentag, mit dem der 1. des Monats beginnt
					let weekdayOfBeginningOfMonth = new Date(year, month.id-1,0).getDay();
					//Anzahl der Zellen pro Monatsansicht
					let numberOfCellsOfCurrentMonth = weekdayOfBeginningOfMonth + maxDaysOfCurrentMonth;
					let items = [];
					let dayOfMonth = '';
					let isSchoolHoliday = false;
					let isPublicHoliday = false;
					let isLegal = false;
					let isToday = false;
					let holidayName = '';


					// c ... cell iterator
					for(let c = 1; c<=numberOfCellsOfCurrentMonth; c++) {



						// weeknumber column
						if(c%7===1) {
							if(c > weekdayOfBeginningOfMonth) {
								dayOfMonth = c-weekdayOfBeginningOfMonth;
							}
							var currentDate = new Date(year,month.id-1,dayOfMonth);
							weekNumber = getWeek(currentDate);

							let key = 'k-' + weekNumber;
							items.push(<CalendarMonthCell content={weekNumber} key={key} />);
						}

						if(c > weekdayOfBeginningOfMonth) {
							dayOfMonth = c-weekdayOfBeginningOfMonth;
							var currentDay = new Date(year,month.id-1,dayOfMonth).toDateString();

							isSchoolHoliday = (schoolHolidays.indexOf(currentDay) >= 0) ? true : false;
							isPublicHoliday = (publicHolidays.indexOf(currentDay) >= 0) ? true : false;
							if(schoolHolidayNames[currentDay]) {
								holidayName = schoolHolidayNames[currentDay];
							}
							else if(publicHolidayNames[currentDay]) {
								holidayName = publicHolidayNames[currentDay];
							}
							else {
								holidayName = '';
							}

							// get index of public holiday, access legal information
							let indexOfPublicHoliday = publicHolidays.findIndex(function(sub) {
								return sub.indexOf(currentDay) !== -1;
							});
							if(indexOfPublicHoliday !== -1) {
								isPublicHoliday = true;
								isLegal = (publicHolidays[indexOfPublicHoliday][1]);
							}
							isToday = (currentDay === new Date().toDateString()) ? true : false;
						}


						// Wenn die letzte Zeile nicht bis Sonntag geht, dann fängt das nächste Monat mit der gleichen Wochennummer an
						if(c === numberOfCellsOfCurrentMonth && numberOfCellsOfCurrentMonth%7!==0) {
							weekNumber--;
						}


						items.push(<CalendarMonthCell content={dayOfMonth} isSchoolHoliday={isSchoolHoliday} isPublicHoliday={isPublicHoliday} isToday={isToday} weekDay={c} isLegal={isLegal} key={c.toString()} holidayName={holidayName} />);
					}

					return	(
						<CalendarMonth month={month} key={month.id}>
							{items}
						</CalendarMonth>
					);

				})}
			</div>
		);
	}
}

Calendar.propTypes = {
	year: PropTypes.number.isRequired,
	region: PropTypes.string,
	dateType: PropTypes.number.isRequired,
	data: PropTypes.object.isRequired
}

export default Calendar;



// WEBPACK FOOTER //
// ./src/components/Calendar.js